<template>
  <div class="row">
    <div class="col-12">
      <div class="d-flex justify-content-end">
        <span v-if="isSaving">
          <b-button variant="primary" size="lg" disabled>
            <b-spinner small />
            {{ 'saving' | i18n }}
          </b-button>
        </span>
        <span v-else>
          <b-button variant="primary" size="lg" :disabled="!selectedYear" @click="create">
            {{ 'save' | i18n }}
          </b-button>
        </span>
      </div>
      <div class="poppins planned-content">
        <div v-if="loaded">
          <div class="row">
            <div class="col-lg-6 col-sm-6 col-12">
              <Select
                v-model="selectedYear"
                :on-change="init"
                :options="yearOptions"
                form-group-id="massCorrectionFactorYear"
                placeholder="year"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-sm-6 col-12 d-flex justify-content-between align-items-center">
              <div>
                {{ 'mass_correction_factor' | i18n }}
              </div>
              <div>
                <Input
                  v-model="massCorrectionFactor"
                  form-group-id="massCorrectionFactor"
                  type="number"
                  step="0.01"
                  placeholder=""
                  :bottom="0"
                />
              </div>
            </div>
          </div>
        </div>
        <Loader v-else />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import api from '../../../api';
import Notification from '../../common/notification';

import Select from '../../common/select';
import Input from '../../common/input';
import Loader from '../../common/loader';

const currentYear = Number(moment().format('YYYY'));
const defaultMassCorrectionFactor = 1.05;

export default {
  title: 'Fabric Data',
  components: { Input, Loader, Select },
  data() {
    return {
      loaded: true,
      isSaving: false,
      massCorrectionFactor: defaultMassCorrectionFactor,
      selectedYear: currentYear,
      yearOptions: [],
    };
  },
  async created() {
    const yearList = await api.year.get();
    this.yearOptions = yearList.data.map(({ year }) => year);
    this.selectedYear = localStorage.getItem('selectedYear') || currentYear;
    this.init();
  },
  methods: {
    async init() {
      localStorage.setItem('selectedYear', this.selectedYear);
      const response = await api.fabricData.get({ year: this.selectedYear });
      if (response && response.massCorrectionFactor) {
        this.massCorrectionFactor = response.massCorrectionFactor;
      } else {
        this.massCorrectionFactor = defaultMassCorrectionFactor;
      }
    },
    async create() {
      try {
        this.isSaving = true;
        await api.fabricData.create({
          massCorrectionFactor: this.massCorrectionFactor,
          year: this.selectedYear,
        });
        Notification({ type: 'success', title: this.$translate('success'), message: this.$translate('success') });
        this.init();
      } catch (err) {
        Notification({ type: 'error', message: err.message });
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.planned-content {
  overflow-x: hidden;
  min-height: 400px;
}

.type-value {
  margin-left: 10px;
  width: 90px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
